<template>
  <div>
    <app-spinner v-if="!page_loaded" />
    <template v-else>
      <app-cells :indent="false">
        <h1 class="title">
          <button
            @click="onCopyLink"
            class="detail-title"
          >
            {{ group_detail.name }} ({{ group_detail.pax }}) ID: {{ $route.params.id }}
          </button>
        </h1>
        <div class="status-title" :style="{ 'backgroundColor': group_detail.type.color || '#5f5f5f' }">
          {{ group_detail.type.name }}
        </div>
        <div v-if="group_detail.water_for_cooking" class="status-tag" style="background-color: #77b017">Bottled water</div>
      </app-cells>
      <div class="info-cards">
        <div class="info-cards__card">
          <div class="info-cards__row">
            <div class="info-cards__row">
              <div class="info-cards__row-item info-cards__row-item--full">
                <span>Route:</span><span>{{ group_detail.route.name }} {{ group_detail.route.duration }}</span>
              </div>
            </div>
          </div>
          <div class="info-cards__row">
            <div class="info-cards__row-item">
              <span>Tour start:</span><span>{{ dateFormat(group_detail.tour_start) }}</span>
            </div>
            <div class="info-cards__row-item">
              <span>Tour finish:</span><span>{{ dateFormat(group_detail.tour_end) }}</span>
            </div>
          </div>
          <div class="info-cards__row">
            <div class="info-cards__row-item">
              <span>Resupply:</span><span>{{ dateFormat(group_detail.resupply) }}</span>
            </div>
          </div>
        </div>
        <div class="info-cards__card">
          <div class="info-cards__row">
            <div class="info-cards__row-item info-cards__row-item--full">
              <span>Chief guide:</span><span>{{ group_detail.chief_guide?.full_name || '-' }}</span>
            </div>
          </div>
          <div class="info-cards__row">
            <div class="info-cards__row-item info-cards__row-item--full">
              <span>Age:</span><span>{{ group_detail.chief_guide?.age || '-' }}</span>
            </div>
          </div>
          <div class="info-cards__row">
            <div class="info-cards__row-item info-cards__row-item--full">
              <span>Rank:</span><span>{{ group_detail.chief_guide?.rank?.name || '-' }}</span>
            </div>
          </div>
        </div>
      </div>
      <app-tabs :tabs="tabs_to_show" />
      <transition name="fade" mode="out-in">
        <router-view
          @edit="onShowModal"
          @delete="onShowDeleteModal"
          :status="group_detail.status"
          :update-key="update_key"
        />
      </transition>
    </template>
    <modal
      name="equip_modal"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="onHideModal('equip_modal')" class="popup__close" type="button"></button>
        <div class="popup__title">Update crew</div>
        <div class="popup__body">
          <form @submit.prevent="sendForm">
            <app-form-group label="Position">
              <app-select
                v-model="form.position"
                :options="position_options"
                :reduce="item => item.code"
                :clearable="false"
                placeholder="Position"
              />
            </app-form-group>
            <app-form-group label="Planned">
              <app-input
                v-model.number="form.planned_count"
                placeholder="Planned"
                type="number"
              />
            </app-form-group>
            <app-form-group label="Real">
              <app-input
                v-model.number="form.real_count"
                placeholder="Real"
                type="number"
              />
            </app-form-group>
            <app-form-group label="Assigned">
              <app-input
                v-model.number="form.assigned_count"
                placeholder="Assigned"
                type="number"
              />
            </app-form-group>
            <app-form-group label="Weight">
              <app-fin-number
                v-model="form.weight"
                placeholder="Weight"
              />
            </app-form-group>
            <app-cells position="center" :indent="false">
              <app-button ref="submit" type="submit">Save</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
    <modal
      name="delete_modal"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="onHideModal('delete_modal')" class="popup__close" type="button"></button>
        <div class="popup__title popup__title--flex">
          <img src="@/assets/img/warning-round-icon.svg" alt="">
          Delete item
        </div>
        <div class="popup__body">
          <div class="popup__subt">Are you sure you want to delete this item?</div>
          <app-cells position="center" :indent="false">
            <app-button @click.native="onHideModal('delete_modal')" theme="dark">Cancel</app-button>
            <app-button @click.native="onDeleteItem" ref="deleteItem">Yes</app-button>
          </app-cells>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import {
  getClimbingGroupsCrewDetail,
  patchClimbingGroupsCrewPositions,
  deleteClimbingGroupsCrewPositions,
  getClimbingMountainCrewPositions
} from '@/http'
import { format, parseISO } from 'date-fns'
import AppTabs from '@/components/AppTabs.vue'

export default {
  name: 'ClimbingGroupsSupplyDetailLayout',
  components: {AppTabs},
  data() {
    return {
      page_loaded: false,
      board_url: process.env.VUE_APP_BOARD_URL,
      group_detail: {},
      tabs: [
        { name: 'climbing-groups-crew-detail-group', label: 'Group', roles: [] },
        { name: 'climbing-groups-crew-detail-resupply', label: 'Resupply', roles: [] },
        { name: 'climbing-groups-crew-detail-tips', label: 'Tips', roles: [] },
      ],
      tabs_to_show: [],
      form: {},
      item_to_action: null,
      update_key: 0,
      position_options: [],
    }
  },
  created() {
    Promise.all([
      getClimbingMountainCrewPositions(),
      getClimbingGroupsCrewDetail(this.$route.params.id)
    ])
      .then(response => {
        this.position_options = response[0].data
        this.group_detail = response[1].data
        this.tabsToShow()
        this.page_loaded = true
      })
  },
  methods: {
    onHideModal(modal_name) {
      this.$modal.hide(modal_name)
    },
    onShowModal(data) {
      this.item_to_action = data.id
      this.form = {
        position: data.position.code,
        planned_count: data.planned_count,
        real_count: data.real_count,
        assigned_count: data.assigned_count,
        weight: data.weight,
      }
      this.$modal.show('equip_modal')
    },
    onShowDeleteModal(item_id) {
      this.item_to_action = item_id
      this.$modal.show('delete_modal')
    },
    onDeleteItem() {
      this.$refs.deleteItem.preload = true
      deleteClimbingGroupsCrewPositions(Number(this.$route.params.id), this.item_to_action)
        .then(() => {
          this.update_key += 1
          this.$notify({
            type: 'success',
            title: 'Item deleted',
          })
          this.onHideModal('delete_modal')
        })
        .catch(() => {
          this.$refs.deleteItem.preload = false
        })
    },
    sendForm() {
      this.$refs.submit.preload = true
      patchClimbingGroupsCrewPositions(Number(this.$route.params.id), this.item_to_action, this.form)
        .then(() => {
          this.update_key += 1
          this.$notify({
            type: 'success',
            title: 'Data saved',
          })
          this.onHideModal('equip_modal')
        })
        .catch(() => { this.$refs.submit.preload = false })
    },
    tabsToShow() {
      const tabs = []
      this.tabs.forEach(item => {
        if (!item.roles.length) {
          tabs.push(item)
          return
        }
        item.roles.forEach(role => {
          if (this.$store.state.userGroups.some(groupRole => groupRole.code === role)) tabs.push(item)
        })
      })
      this.tabs_to_show = tabs
    },
    onCopyLink() {
      const string = `${this.board_url}climbing/groups-supply/${this.$route.params.id}`
      navigator.clipboard.writeText(string)
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Copied to clipboard',
          })
        })
        .catch(() => { console.error('Something went wrong') })
    },
    dateFormat(date) {
      return date ? format(parseISO(date), 'dd MMM yyyy') : '-'
    },
  }
}
</script>

<style lang="sass">
.detail-title
  color: $color-text-base
  font-size: 24px
  font-weight: 600
  transition: color 0.3s

  &:hover
    color: $color-theme

.detail-holder
  display: grid
  grid-template-columns: repeat(2, 1fr)
  gap: 10px 20px
  margin-bottom: 20px
  align-items: stretch

.detail-editor .ql-editor
  min-height: 52px

.detail-editor .ql-container
  height: auto
</style>

